export { fetchPublisherData } from 'next-flight-server-reference-proxy-loader?id=004b36274c96ea874b9c33e14e1a91100c9e4bdca5&name=fetchPublisherData!'